import manageAdaptationNotesModalEn from "./locales/en.json";

export const MANAGE_ADAPTATION_NOTES_MODAL_NS =
  "manageAdaptationNotesModal" as const;

export const ManageAdaptationNotesModalI18n = {
  en: {
    [MANAGE_ADAPTATION_NOTES_MODAL_NS]: {
      ...manageAdaptationNotesModalEn,
    },
  },
};
